import { render, staticRenderFns } from "./SettingsEditProfile.vue?vue&type=template&id=7d67f072&scoped=true&"
import script from "./SettingsEditProfile.vue?vue&type=script&lang=js&"
export * from "./SettingsEditProfile.vue?vue&type=script&lang=js&"
import style0 from "./SettingsEditProfile.vue?vue&type=style&index=0&id=7d67f072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d67f072",
  null
  
)

export default component.exports